import React, { useMemo } from "react";
import EnquireForm from "../../Home/enquire/EnquireForm";
import { fieldDevelop } from "../../Home/enquire/TabContentConfig";
import background from "../../../assets/images/contact/service-contact.jpg";

export default function GetInTouchSection() {
  const tabContent = useMemo(
    () => [
      {
        id: 1,
        mapID: fieldDevelop,
        uniqKey: "__get_quotation",
        content: "Get Quotation",
      },
    ],
    [fieldDevelop]
  );

  const tabContentData = useMemo(() => {
    const activeTab = tabContent.find((item) => item.id === 1);
    return activeTab ? activeTab.mapID : [];
  }, [tabContent]);

  return (
    <section className="contact-four py-120 rpy-100">
      <div className="container">
        <div className="contact-inner-four box-shadow p-35 rpx-25 br-5 bg-white">
          <div className="row">
            <div className="col-lg-7">
              <div className="contact-section-form px-15 rpx-0 rmb-50 wow fadeInUp delay-0-2s animated">
                <div className="section-title mb-20">
                  <h2>Get In Touch</h2>
                </div>
                <div id="contact-form" className="contact-form"></div>
                <EnquireForm formElements={tabContentData} tab={1} />
              </div>
            </div>
            <div className="col-lg-5">
              <div
                className="contact-image-number style-two bgs-cover overlay wow fadeInUp delay-0-4s animated"
                style={{
                  backgroundImage: `url(${background})`,
                  visibility: "visible",
                  animationName: "fadeInUp",
                }}
              >
                <div className="contact-informations text-white">
                  <h3>Turn your vision into reality</h3>
                  <ul className="contact-info">
                    <li>
                      <i className="fas fa-phone-alt"></i>
                      <div className="content">
                        <span>Call Us</span>
                        <h5>
                          <a href="callto:+012-345-6789">+91-8851373820</a>
                        </h5>
                      </div>
                    </li>
                    <li>
                      <i className="fas fa-envelope"></i>
                      <div className="content">
                        <span>Write to Us</span>
                        <h5>
                          <a href="mailto:contact@example.com">
                            contact@nextcosmostechnology.com
                          </a>
                        </h5>
                      </div>
                    </li>
                    <li>
                      <i className="fas fa-globe"></i>
                      <div className="content">
                        <span>Website</span>
                        <h5>
                          <a href="https://nextcosmostechnology.com/">
                            www.nextcosmostechnology.com
                          </a>
                        </h5>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
